<template>
  <div class="chat-system-message" @click.stop="handleClick">
    <FriedIconButton
      data-external="chat-system-message-close-button"
      class="close-button"
      @click.stop="handleClose"
    >
      <FriedIcon :size="IconSize.Small" icon="close" class="close-icon" />
    </FriedIconButton>
    <FriedAvatar
      v-if="sender.thumbUrl"
      :thumb-url="sender.thumbUrl"
      class="thumb"
      alt="sender profile picture"
    />
    <FriedParagraph>
      {{ $t('hi-there') }} <HandEmoji class="emoji" />
      {{ $t(`im-here-if-you-have-any-questions`) }}
    </FriedParagraph>
  </div>
</template>

<script lang="ts">
import { IconSize } from '@getaccept/fried-tofu';
import type { SigningPageUser } from '@getaccept/lib-shared-new/src/types/signing-page-user';
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import HandEmoji from '../assets/hand-emoji.svg';

export default defineComponent({
  components: {
    HandEmoji,
  },
  props: {
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
  },
  emits: ['click', 'close'],
  setup(_, { emit }) {
    const handleClose = () => {
      emit('close');
    };

    const handleClick = () => {
      emit('click');
    };

    return {
      IconSize,
      handleClose,
      handleClick,
    };
  },
});
</script>

<style lang="scss" scoped>
$message-height: 106px;
$message-width: 24rem;
$chat-fab-with-margin: calc(#{var(--chat-size)} + #{var(--spacing-200)});
$chat-window-bottom-position: calc(
  #{$chat-fab-with-margin} + #{var(--bottombar-height)} + #{var(--spacing-100)}
);

.chat-system-message {
  border-radius: var(--radius-medium);
  background: var(--white);
  box-shadow: var(--shadow-2);
  height: $message-height;
  width: $message-width;
  position: fixed;
  bottom: $chat-window-bottom-position;
  right: var(--spacing-150);
  display: flex;
  align-items: center;
  padding: var(--spacing-100);
  color: var(--text-dark);
  cursor: pointer;

  @media only screen and (max-width: $xs) {
    display: none;
  }

  @media only screen and (max-width: $md) {
    right: var(--spacing-100);
  }

  .close-button {
    position: absolute;
    right: var(--spacing-25);
    top: var(--spacing-25);
  }

  .thumb {
    border: 3px solid var(--white);
    position: absolute;
    transform: translateX(-50%);
    top: -20px;
    left: 50%;
  }

  .emoji {
    margin: 0 var(--spacing-25);
    animation: wiggle 2.5s infinite;
  }

  @keyframes wiggle {
    0% {
      transform: rotate(0deg);
    }

    80% {
      transform: rotate(0deg);
    }

    85% {
      transform: rotate(10deg);
    }

    95% {
      transform: rotate(-10deg);
    }

    100% {
      transform: rotate(0deg);
    }
  }
}
</style>
